import React from 'react';

import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
  Form,
  CardTitle,
  CardFooter
  
} from 'reactstrap';
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";


import ModalForm from '../modal/modal'
import AgentNewtkt from '../TicketForms/AgentNewTicket'
import MediaQuery from 'react-responsive'

import AuthService from "services/auth.service";
import {columnsForSAP, columns,customStyles } from "variables/tablecoulmns";

import Timestamp from "react-timestamp";
import Loader from "react-loader-spinner";


import "./styles.css";
import Tform from '../TicketForms/Tktviewform'






//const viewQuery ="SELECT ID,name,class FROM school ";
 class DTable extends React.Component {
   
    constructor(props) {
        super(props);
        let userrole = ''
         if(  AuthService.getCurrentUser().roles.includes('ROLE_ADMIN')){userrole = 'IT Service'}

       else if(  AuthService.getCurrentUser().roles.includes('ROLE_HELPDESK')){userrole = 'HelpDesk'}
       else if(  AuthService.getCurrentUser().roles.includes('ROLE_SYSTEM')){userrole = 'System'}
       else if(  AuthService.getCurrentUser().roles.includes('ROLE_NETWORK')){userrole = 'Network'}
       else if(  AuthService.getCurrentUser().roles.includes('ROLE_SAP')){userrole = 'SAP'}

      
if (this.props.targetstate && userrole !=='SAP'){userrole = 'IT Service'} 


        this.state = {
            viewdata:[
              {
                  "id": 22550,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Maintainance",
                  "description": "Kindly issue a Laptop case\nregards",
                  "queue": "HelpDesk",
                  "category": "SAP Reservation",
                  "sub": "Create Reservation",
                  "state": "Pending",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "false",
                  "ipadd": "50.50.50.152",
                  "createdAt": "2022-02-28T12:31:07.000Z",
                  "updatedAt": "2022-02-28T12:39:21.000Z"
              },

              {
                  "id": 22535,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site2 site datacenter and update \"Site2\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-28T08:00:00.000Z",
                  "updatedAt": "2022-02-28T10:11:07.000Z"
              },
              {
                  "id": 22517,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site2 site datacenter and update \"Site2\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Achieved",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-27T08:00:00.000Z",
                  "updatedAt": "2022-02-27T10:04:36.000Z"
              },
              {
                  "id": 22515,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "NonUpdated",
                  "description": "Outlook Status is Working Offline",
                  "queue": "HelpDesk",
                  "category": "Email",
                  "sub": "Outlook working offline",
                  "state": "Waiting For User",
                  "slares": "Achieved",
                  "actsla": "Achieved",
                  "author": "test.user",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.50.183",
                  "createdAt": "2022-02-26T08:04:28.000Z",
                  "updatedAt": "2022-02-27T07:11:39.000Z"
              },
              {
                  "id": 22514,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Not Updated",
                  "description": "----HR leave tracker---- Application Always Hang",
                  "queue": "HelpDesk",
                  "category": "Applications",
                  "sub": "Software Hang",
                  "state": "Waiting For User",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "test.user",
                  "sapreqnum": "None",
                  "site": "Site1",
                  "resolution": "true",
                  "ipadd": "50.50.39.20",
                  "createdAt": "2022-02-24T10:23:17.000Z",
                  "updatedAt": "2022-02-27T07:07:06.000Z"
              },
              {
                  "id": 22504,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning a, \n   You are kindly requested to take the weekly configuration backup \n   for all IT infrastructure devices under your supervision.",
                  "queue": "HelpDesk",
                  "category": "Configuration Backup",
                  "sub": "Weekly Configuration Backup",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-23T08:05:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22503,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to take the weekly configuration backup \n   for all IT infrastructure devices under your supervision.",
                  "queue": "Systems",
                  "category": "Configuration Backup",
                  "sub": "Weekly Configuration Backup",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-23T08:05:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22502,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to take the weekly configuration backup \n   for all IT infrastructure devices under your supervision.",
                  "queue": "Systems",
                  "category": "Configuration Backup",
                  "sub": "Weekly Configuration Backup",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-23T08:05:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22498,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site2 site datacenter and update \"Site2\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-23T08:00:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22489,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site2 site datacenter and update \"Site2\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-22T08:00:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22478,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site2 site datacenter and update \"Site2\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-21T08:00:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22466,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to perform the daily health check \n   for Site2 site datacenter and update \"Site2\" Excel sheet\n   on the below link:\n     then please update on this ticket with any technical issues if exist or just comment with \"All Ok\" if not.",
                  "queue": "Systems",
                  "category": "DataCenter",
                  "sub": "Daily Health Check",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-20T08:00:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22450,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning a, \n   You are kindly requested to take the weekly configuration backup \n   for all IT infrastructure devices under your supervision.",
                  "queue": "HelpDesk",
                  "category": "Configuration Backup",
                  "sub": "Weekly Configuration Backup",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-16T08:05:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22449,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "IT",
                  "description": "Good Morning , \n   You are kindly requested to take the weekly configuration backup \n   for all IT infrastructure devices under your supervision.",
                  "queue": "Systems",
                  "category": "Configuration Backup",
                  "sub": "Weekly Configuration Backup",
                  "state": "Open",
                  "slares": "Violated",
                  "actsla": "Violated",
                  "author": "HelpDesk System",
                  "sapreqnum": "None",
                  "site": "Site2",
                  "resolution": "false",
                  "ipadd": "50.50.50.20",
                  "createdAt": "2022-02-16T08:05:00.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              },
              {
                  "id": 22257,
                  "agent": "test.agent",
                  "client": "test.user",
                  "department": "Maintenance - Planning",
                  "description": "Drum is damaged and black points appear on any printed paper",
                  "queue": "HelpDesk",
                  "category": "Printer",
                  "sub": "Drum Issue",
                  "state": "Pending",
                  "slares": "Achieved",
                  "actsla": "Violated",
                  "author": "test.user",
                  "sapreqnum": "None",
                  "site": "Site5",
                  "resolution": "true",
                  "ipadd": "50.50.50.39",
                  "createdAt": "2022-01-26T06:57:15.000Z",
                  "updatedAt": "2022-02-27T07:04:36.000Z"
              }
          ],
            loading:false,
            selectedRows: [],
            isOpen: false,
            isOpenNewtkt:false,
            targetid:'',
            ftkts:this.props.targetstate ? this.props.targetstate : 'Active',//01009518284  update 22-9-2021
            queue:userrole,
            isomits:window.innerWidth <= 1600 
        };

      }




 componentDidMount() {



}

componentWillUnmount(){

  clearInterval(this.interval);
}






 
 handleButtonClick = (state) => {
    //alert('action Clicked for Row Number'+ state.target.id);
    this.setState({ isOpen: true , targetid: state.target.id});
  };
  handleChange = state => {

    this.setState({ selectedRows: state.selectedRows });
  };







  handleFilterChange = (e) =>{ 
  

    let Filterpromise = new Promise((myResolve, myReject) =>{ 
    
    // The producing code (this may take some time)
    this.setState({[e.target.name]: e.target.value})
  
  
  
  
        myResolve(e.target.name);
        myReject("Error");
      
  
  
  
  
    });
    
    Filterpromise.then(
      (error)  =>{}
    );
    
    
    
  
  //handleChange = (e) =>{ this.setState({[e.target.name]: e.target.value})
  
  
  }





  openModal = () => this.setState({ isOpen: true });
  closeModal = () => {this.setState({ isOpen: false ,targetid:''});}


  openModalNewtkt = () => this.setState({ isOpenNewtkt: true });

  closeModalNewtkt = () => {this.setState({ isOpenNewtkt: false ,targetid:''});}


  render(){
    let data = this.state.viewdata
    const tableData = {
      columns,
      data
    };

let coulmstoview = this.state.queue === 'SAP' ? columnsForSAP(this.handleButtonClick , this.state.isomits) : 

this.state.queue === 'IT Service' ? columns(this.handleButtonClick, this.state.isomits ,  true):columns(this.handleButtonClick, this.state.isomits ,  this.state.isomits);





  return (
<div>
{ this.state.loading ? 
  <Row className="justify-content-center align-items-center" >

<Loader
        type="Puff"
        color="rgb(101, 153, 57)"
        height={150}
        width={150}
        timeout={15000} //3 secs
      /></Row>
:
<div>
<CardHeader>
                  <h5 className="title">{this.state.ftkts} Tickets For {this.state.queue} Team </h5>

                </CardHeader>

<Form>

      <FormGroup>
        <Row>





        <Col xs={12} md={4}>
          <Label for="quefilter">Queue</Label>
          <Input type="select" name="queue" id="quefilter" onChange={this.handleFilterChange}  value={this.state.queue}>
            <option>HelpDesk</option>
            <option>System</option>
            <option>Network</option>
            <option>SAP</option>
            <option>IT Service</option>  //01009518284  update 22-9-2021

          </Input>
          </Col>

          <Col xs={12} md={4}>
          <Label for="statefilter">Filter By State</Label>
          <Input type="select" name="ftkts" id="statefilter" onChange={this.handleFilterChange}  value={this.state.ftkts}>
          <option>Active</option> //01009518284  update 22-9-2021
            <option>Open</option>
            <option>In Progress</option>
            <option>Waiting For User</option>
            <option>Pending</option>
            <option>Completed</option>
            <option>Closed</option>
            <option>Canceled</option>

            <option>All</option>  //01009518284  update 22-9-2021

          </Input>
          </Col>
          <Col xs={12} md={4}>
          <Label for="gtidfilter">Get Ticket By ID</Label>
          <Input type="text" name="targetid" id="gtidfilter" onChange={this.HandleGtktByid}  value={this.state.targetid}  />
         
          </Col>

          </Row>
</FormGroup>
</Form>








<Button onClick={this.openModalNewtkt} style={{backgroundColor:'rgb(130, 190, 80)'}}  >Submit New Ticket</Button>

<MediaQuery minDeviceWidth={1244}>

<Row>
<Col lg={12} md={12}>
      <DataTableExtensions columns={coulmstoview}  data={data} exportHeaders print={false} filterPlaceholder="Search">


                <DataTable

                data={this.state.viewdata}
                
                columns={coulmstoview}
                onRowSelected={this.handleChange}
              customStyles={customStyles}
                  //style={{maxWidth:'80vw'}}
                pagination
                paginationPerPage={20}
                paginationRowsPerPageOptions={[10, 20, 50, 100  ]	}
                selectableRows
                responsive
                highlightOnHover
                noHeader = {this.state.isomits}
                striped

                />

                      </DataTableExtensions>
                      </Col>
                      </Row>
</MediaQuery>

<MediaQuery maxDeviceWidth={1244} >
<Row >
     {this.state.viewdata.map((tkt) => {
      return (
    
    
            <Col xs={12} md={4}
          
          key={tkt.id} >
 
    <Card  style={{ boxShadow: '  0 0 5px gray,  0 0 20px gray,  0 0 5px gray',
}}>
                <CardHeader  className="text-center">
                  <CardTitle tag="strong" style={{color:"green"}}>Ticket# {tkt.id} - {tkt.sub}</CardTitle>
<hr/>
                </CardHeader>



                <CardBody>
<ul style={{color:"rgb(65,70,75)"}}>
<li><strong>Client:</strong> {tkt.client}</li>

<li><strong>Status:</strong> {tkt.state}</li>
<li><strong>Category:</strong> {tkt.category}</li>

<li><strong>Sub-Category:</strong> {tkt.sub}</li>
<li><strong>Created:</strong> <Timestamp relative date={tkt.createdAt} autoUpdate /></li>
<li><strong>Last Update:</strong> <Timestamp relative date={tkt.updatedAt} autoUpdate /></li>



</ul>

                </CardBody>



                <CardFooter className="text-center" >
                <hr/>

                <Button onClick={this.handleButtonClick} id={tkt.id} style={{backgroundColor:'rgb(101, 153, 57)'}  } >View/Edit</Button>
                </CardFooter>
              </Card>

              


          </Col>
       
      );
    })}
    
    
    </Row>

</MediaQuery>






                      </div>
}
        { this.state.isOpen ? 
          <ModalForm 
            closeModal={this.closeModal} 
            isOpen={this.state.isOpen} 
            title={"Ticket# " + this.state.targetid}
            hoste={<Tform tktid={this.state.targetid}></Tform>}
            size="lg"
          /> 
          : 
          null 
        }


        { this.state.isOpenNewtkt ? 
          <ModalForm 
            closeModal={this.closeModalNewtkt} 
            isOpen={this.state.isOpenNewtkt} 
            title={"Submit New Ticket"}
            hoste={<AgentNewtkt  defaultqueue={this.state.queue}

 />}
            size="md"
          /> 
          : 
          null 
        }





</div>

  );
}
}
export default DTable;
